import React from 'react';

/* Real Lucide glyphs, read from the Lucide UMD build on the page
   (window.lucide.icons). 16px on a 16px grid, 1.5px stroke, currentColor —
   never a hand-drawn path. If Lucide has not loaded the component renders an
   empty box of the right size so layout is unaffected. */

const pascal = (n) =>
  String(n).split(/[-_\s]+/).map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join('');

function nodes(icon) {
  if (!icon) return null;
  if (Array.isArray(icon) && icon[0] === 'svg') return icon[2] || [];
  if (Array.isArray(icon)) return icon;
  if (icon && Array.isArray(icon.children)) return icon.children;
  return null;
}

export function Icon({ name, size = 16, strokeWidth = 1.5, filled = false, title, style, ...rest }) {
  const lib = typeof window !== 'undefined' && window.lucide ? window.lucide.icons || window.lucide : null;
  const icon = lib ? lib[pascal(name)] || lib[name] : null;
  const kids = nodes(icon) || [];

  return React.createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 24 24',
      fill: filled ? 'currentColor' : 'none',
      stroke: 'currentColor',
      strokeWidth,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      role: title ? 'img' : undefined,
      'aria-hidden': title ? undefined : true,
      focusable: 'false',
      style: { display: 'block', flex: '0 0 auto', ...style },
      ...rest,
    },
    title ? React.createElement('title', { key: 't' }, title) : null,
    kids.map((c, i) => React.createElement(c[0], { key: i, ...c[1] }))
  );
}
